export const header = {
	start: { pl: 'Start' },
	video: { pl: 'Film' },
	about: { pl: 'O aplikacji' },
	functions: { pl: 'Funkcje' },
	download: { pl: 'Pobierz' }
};
